import { Button, DatePicker, Form } from "antd";
import React, { useEffect, useRef, useState } from "react";
// import VerifyModal from "../../../Common/VerifyModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../../Store/B2bslice";
import {
  aadharPattern,
  mobilePattern,
  pincodePattern,
} from "../../../../Utils";
import VerifyModal from "../../../../Common/VerifyModal";
import CommonInput from "../../../../Common/CommonInput";
import { addEkoDmtCustomers, EkoEndpoint } from "../EkoEndpoint";
import VerifyCustomerModal from "./VerifyCustomerModal";

const CustomerReg = () => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const formref = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState({});
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setselectedTab("4"));
    if (!memberServices.includes("4")) {
      navigate("/not-Available");
    }
  }, []);
  const handleAdd = (val) => {
    setBtnLoading(true);

    const formdata = new FormData();
    Object.entries(val).forEach(([key, value]) => {
      if (key === "aadhar") return;

      if (key === "dob" && value) {
        // Format the date to "YYYY-MM-DD"
        const formattedDate = value.format("YYYY-MM-DD");
        formdata.append(key, formattedDate);
      } else {
        formdata.append(key, value);
      }
    });

    addEkoDmtCustomers(formdata)
      .then((res) => {
        if (res.status) {
          setResponse(res.data);
          setIsOpen(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full lg:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2">Add Customer</p>
          <Form
            name="basic"
            form={form}
            ref={formref}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleAdd(val)}
          >
            <Form.Item
              name={`mobile`}
              label={"Mobile Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Mobile Number!",
                },
                {
                  pattern: mobilePattern,
                  message: "Please enter a valid mobile number",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Mobile Number!"
                name="mobile"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`aadhar`}
              label={"Aadhaar Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter aadhaar no.!",
                },
                {
                  pattern: aadharPattern,
                  message: "Please enter valid aadhaar",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Your First Name!"
                name="aadhar"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`name`}
              label={"Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter name.!",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your  Name!" name="name" />
            </Form.Item>{" "}
            <Form.Item
              name={`dob`}
              label={"Date Of Birth"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter DOB!",
                },
              ]}
            >
              <DatePicker
                className="w-full"
                placeholder="Enter DOB"
                name="dob"
                format="YYYY-MM-DD"
              />
            </Form.Item>{" "}
            <Form.Item>
              <Button
                htmlType="submit"
                loading={btnLoading}
                className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
              >
                Submit
              </Button>
            </Form.Item>{" "}
          </Form>
        </div>
      </div>
      {isOpen && (
        <VerifyCustomerModal
          isOpen={isOpen}
          from="register"
          setIsOpen={setIsOpen}
          endpoint={EkoEndpoint.verifyCustomerOtp}
          otherFields={{
            mobile: form.getFieldValue("mobile"),
            aadhar: form.getFieldValue("aadhar"),
            // otp_ref_id: response.otprefrenceid,
            // otp: response?.otp,
            // kyc_request_id: response?.kyc_request_id,
            pid_option_wadh: "18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=",
          }}
        />
      )}
    </>
  );
};

export default CustomerReg;
